import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getAvailableProducts() {
  return request({
    url: '/mercoTimerCycleHistory/knownProducts',
    method: 'get',
  });
}

export function getMercoTimerCycleHistory(params, signal) {
  return request({
    url: '/mercoTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getMercoTimerCycleHistoryTotal(params, signal) {
  return request({
    url: '/mercoTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function exportMercoTimerCycleHistory(params) {
  return request({
    url: '/mercoTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteMercoTimerCycle(uuid) {
  return request({
    url: `/mercoTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const mercoApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteMercoTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/mercoTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteMercoTCHsMutation: useBulkDeleteMercoTCHs,
} = mercoApi;

export default mercoApi;
